import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { HelpSVG } from '../svg/help.svg';

const HelpIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <HelpSVG/>
    </div>
  );
};

export { HelpIcon };
